import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from "prop-types";

import gsap from "gsap";
import "@pixi/events";
import { Container, Text, Graphics } from '@pixi/react';
import { TextStyle } from "pixi.js";

const GameButton = (props) => {
    const ref = useRef();

    const [width, height] = [props.width || 100, props.height || 50];

    const draw = useCallback((g) => {
        g.clear();
        g.lineStyle(2, 0xffffff, 1);
        g.beginFill(0xffffff, 1);
        g.drawRoundedRect(0, 0, width, height, 15);
        g.endFill();
      }, []);

    const onOver = () => {
        const [graphics, text] = ref.current.children;
        gsap.fromTo(graphics, { tint: graphics.tint }, { tint: "#AAAAAA", ease: "linear", duration: 0.2 });
        gsap.fromTo(text.scale, { x: 1, y: 1 }, { x: 1.1, y: 1.1, ease: "linear", duration: 0.2 });
    };
    const onOut = () => {
        const [graphics, text] = ref.current.children;
        gsap.fromTo(graphics, { tint: graphics.tint }, { tint: "#DDDDDD", ease: "linear", duration: 0.2 });
        gsap.fromTo(text.scale, { x: 1.1, y: 1.1 }, { x: 1, y: 1, ease: "linear", duration: 0.2 });
    };
    const onDown = () => { ref.current.children[0].tint = "#DDD000"; };
    const onUp = () => {
        ref.current.children[0].tint = "#DDDDDD";
        props.onclick();
    };
    
    useEffect(() => {
        const graphics = ref.current.children[0];
        graphics.tint = "#DDDDDD";
    }, []);

    return <Container
        ref = { ref }
        name = { props.name }
        buttonMode
        eventMode = { props.disabled ? 'none' : 'static' }
        cursor = 'pointer'
        width = { width }
        height = { height }
        alpha = { props.alpha }
        pointerover = { onOver }
        pointerout = { onOut }
        pointerdown = { onDown }
        pointerup = { onUp }
        x = { props.x || 0 }
        y = { props.y || 0 }
        pivot = { props.pivot || null }
    >
        <Graphics draw = { draw } />
        <Text
            text = { props.label }
            x = { width * 0.5 }
            y = { height * 0.5 }
            anchor = { 0.5 }
            style = {
                new TextStyle({
                    align: 'center',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: props.fontSize || 50,
                    fill: props.textColor || "#000000",
                })
            }
        />
    </Container>;
};

GameButton.propTypes = {
    image: PropTypes.string,
    fontSize: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    strokeThickness: PropTypes.number,
    notScalableArea: PropTypes.number,
    label: PropTypes.string,
    onclick: PropTypes.func,
    disabled: PropTypes.bool,
    textColor: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
    alpha: PropTypes.number,
    name: PropTypes.string,
    pivot: PropTypes.object,
};

export default GameButton;